import { TextFieldProps as MuiTextFieldProps } from '@mui/material/TextField'
import { FieldProps, getIn } from 'formik'
import { NumbersOnlyTextField as MuiTextField } from '../inputs'

export interface NumbersOnlyTextFieldProps
  extends FieldProps,
    Omit<MuiTextFieldProps, 'name' | 'value' | 'error'> {}

function fieldToNumbersOnlyTextField({
  disabled,
  field: { onBlur: fieldOnBlur, ...field },
  form: { isSubmitting, touched, errors },
  onBlur,
  helperText,
  ...props
}: NumbersOnlyTextFieldProps): MuiTextFieldProps {
  const fieldError = getIn(errors, field.name)
  const showError = getIn(touched, field.name) && !!fieldError

  return {
    error: showError,
    helperText: showError ? fieldError : helperText,
    disabled: disabled ?? isSubmitting,
    onBlur:
      onBlur ??
      function (e) {
        fieldOnBlur(e ?? field.name)
      },
    ...field,
    ...props,
  }
}

export function NumbersOnlyFormikTextField({ children, ...props }: NumbersOnlyTextFieldProps) {
  return <MuiTextField {...fieldToNumbersOnlyTextField(props)}>{children}</MuiTextField>
}

NumbersOnlyFormikTextField.displayName = 'FormikMaterialUITextField'
